import { keys } from "lodash";
import { FC } from "react";
import { Link } from "react-router";

interface MaintenanceItem {
  mileage: string;
  categories: {
    name: string;
    link: string;
  }[];
  color: string;
}

type MaintenanceItemArray = {
  [key: string]: MaintenanceItem[];
}
const maintenanceData: MaintenanceItemArray = {
  "#4ADE80": [
    {
      mileage: "10 000 км",
      categories: [
        {
          name: "Моторное масло",
          link: "/category/e276d40a-9721-11e1-82a9-00e052d08354",
        },
        {
          name: "Масляный фильтр",
          link: "/category/65cdefa3-11e9-11e0-b310-0016eab4cd54",
        },
      ],
      color: "#4ADE80",
    },
    {
      mileage: "15 000 км",
      categories: [
        {
          name: "Фильтр воздушный",
          link: "/category/3ee43c7a-11e9-11e0-b310-0016eab4cd54",
        },
        {
          name: "Фильтр салона",
          link: "/category/9eeda6a6-11e9-11e0-b310-0016eab4cd54",
        },
        {
          name: "Топливный фильтр",
          link: "/category/b1118300-11e9-11e0-b310-0016eab4cd54",
        },
      ],
      color: "#4ADE80",
    },
    {
      mileage: "20 000 км",
      categories: [
        {
          name: "Тормозные колодки",
          link: "/category/58c8806d-11e9-11e0-b310-0016eab4cd54",
        },
        { name: "Щетки стеклоочистителя", link: "/category/d126402e-11e9-11e0-b310-0016eab4cd54" },
      ],
      color: "#4ADE80",
    },
  ],
  "#FF9500": [
    {
      mileage: "40 000 км",
      categories: [
        {
          name: "Свечи зажигания",
          link: "/category/9eeda73f-11e9-11e0-b310-0016eab4cd54",
        },
      ],
      color: "#FB923C",
    },
    {
      mileage: "50 000 км",
      categories: [
        {
          name: "Тормозные диски",
          link: "/category/4bc22707-11e9-11e0-b310-0016eab4cd54",
        },
      ],
      color: "#FB923C",
    },
    {
      mileage: "60 000 км",
      categories: [
        {
          name: "Масло трансмиссионное",
          link: "/category/e276d40b-9721-11e1-82a9-00e052d08354",
        },
      ],
      color: "#FB923C",
    },
    {
      mileage: "70 000 км",
      categories: [
        { name: "Детали подвески", link: "/category/31dde1b7-11e9-11e0-b310-0016eab4cd54" },
      ],
      color: "#FB923C",
    },
    {
      mileage: "75 000 км",
      categories: [{ name: "Лампы головного света", link: "/category/65cdef5f-11e9-11e0-b310-0016eab4cd54" }],
      color: "#FB923C",
    },
  ],
  "#FF3B30": [
    {
      mileage: "90 000 км",
      categories: [{ name: "Сигнальные лампы", link: "/category/65cdef5f-11e9-11e0-b310-0016eab4cd54" }],
      color: "#EF4444",
    },
    // {
    //   mileage: "125 000 км",
    //   categories: [{ name: "Аккумулятор", link: "/category/fbb0052f-37a0-11e3-abdc-902b34102091" }],
    //   color: "#EF4444",
    // },
  ],
};

const MaintenanceParts: FC = () => {
  return (
    <div className="bg-[#383181] rounded-[20px] p-[20px]  shadow-[0px_2px_20px_rgba(0,0,0,0.10)] relative ">
      <div className="flex flex-col sm:flex-row gap-[20px] md:gap-[25px]">
        <div className="flex-shrink-0">
          <h3 className="text-white text-[18px] md:text-[24px] font-bold leading-[100%] tracking-[-0.02em]">
            Запчасти
            <br />
            для ТО
          </h3>
        </div>
        {/* Timeline and Items Section */}
        <div className="flex flex-col gap-[10px]">
          {keys(maintenanceData).map((i) => (
        <div className={`flex flex-row gap-[8px]  text-[white]  w-full h-full`}>
          <div className=" w-[5px] rounded-[10px] " style={{
            backgroundColor: i
          }}></div>
          <div className="flex flex-col gap-[4px]">
            {maintenanceData[i].map((j) => (
                <div className="flex flex-col">
                  <div className="flex flex-row items-center gap-[20px]">
                    <span className=" text-[12px] md:text-[14px] w-[65px] self-start tracking-[-0.02em] whitespace-nowrap" style={{
                      fontWeight: 500
                    }}>
                      {j.mileage}
                    </span>
                    <div className="flex flex-col gap-[4px]">
                      {j.categories.map((k) => (
                        <Link className="text-[14px] font-[300] tracking-[-0.02em] text-left" to={k.link}>
                          {k.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div> 
            ))}
          </div>
          </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MaintenanceParts;
